



// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { FaMoneyBillWave } from "react-icons/fa";
// import { IoMdClose } from "react-icons/io";
// import logo from "./../assets/dectwin-billing-logo.jpeg";
// import { FaShoppingCart } from "react-icons/fa";
// import { IoIosClose } from "react-icons/io";
// import { GrOverview } from "react-icons/gr";
// import { FaCoins } from "react-icons/fa";
// import { FaUsers } from "react-icons/fa";
// import { FaBoxOpen } from "react-icons/fa";
// import { GrUserManager } from "react-icons/gr";
// import { CiBank } from "react-icons/ci";
// import { FaHandHoldingUsd } from "react-icons/fa";
// import { FaUserPlus } from "react-icons/fa";
// import { IoMdNotifications } from "react-icons/io";
// import { IoSettingsSharp } from "react-icons/io5";
// import { MdOutlineWorkspacePremium } from "react-icons/md";
// import { TbReportSearch } from "react-icons/tb";
// import { FaMoneyCheck } from "react-icons/fa";

// import { FaSignOutAlt } from "react-icons/fa";
// import { IoHome } from "react-icons/io5";
// import { FaFileInvoiceDollar } from "react-icons/fa";
// import { FaReceipt } from "react-icons/fa";
// import { FaBarcode } from "react-icons/fa";
// import { FaTags } from "react-icons/fa";
// import { IoCardOutline } from "react-icons/io5";

// import {
//   showSuccess,
// } from "../General/Toast";

// function Sidebar({
//   setShowSidebar,
//   setIsLogin,
//   role,
//   clientData,
// }) {
//   const navigate = useNavigate();

//   const [hovered, setHovered] = useState(null);
//   const [open, setOpen] = useState(true);
//   const [isMobile, setIsMobile] = useState(false);
//   const [showLogoutModal, setShowLogoutModal] = useState(false);

//   console.log("ROLE:", role);
//   console.log("CLIENT DATA:", clientData);
//   console.log("ACTIONS:", clientData?.actions);

// useEffect(() => {
//   try {
//     const userData = JSON.parse(localStorage.getItem("user_data"));

//     console.log("========== STAFF LOGIN DATA ==========");
//     console.log("USER DATA:", userData);
//     console.log("USER ROLE:", userData?.role);
//     console.log("USER ACTIONS:", userData?.actions);
//     console.log("SIDEBAR CLIENT DATA:", clientData);
//     console.log("SIDEBAR CLIENT ACTIONS:", clientData?.actions);
//   } catch (error) {
//     console.error("user_data parse error:", error);
//   }
// }, [clientData]);

// const getStaffActions = () => {
//   try {
//     const storedUser = localStorage.getItem("user_data");

//     if (!storedUser) {
//       return [];
//     }

//     const userData = JSON.parse(storedUser);

//     let actions = userData?.actions;

//     if (!actions) {
//       return [];
//     }

//     while (typeof actions === "string") {
//       actions = JSON.parse(actions);
//     }

//     if (!Array.isArray(actions)) {
//       return [];
//     }

//     return actions
//       .map((action) =>
//         String(action).toLowerCase().trim()
//       )
//       .filter(Boolean);

//   } catch (error) {
//     console.error("Staff permission error:", error);
//     return [];
//   }
// };

 
// const menuItems = [
//   {
//     id: 1,
//     label: "Home",
//     icon: <IoHome size={26} />,
//     path: "/home",
//     permission: null,
//   },

  
//   {
//     id: 3,
//     label: "Overview",
//     icon: <GrOverview size={26} />,
//     path: "/overview",
//     permission: null,
//   },

//   {
//     id: 4,
//     label: "Parties",
//     icon: <FaUsers size={26} />,
//     path: "/party",
//     permission: "addParty",
//   },

//   {
//     id: 5,
//     label: "Inventory",
//     icon: <FaBoxOpen size={26} />,
//     path: "/items",
//     permission: "inventory",
//   },

//   {
//     id: 6,
//     label: "Manage Business",
//     icon: <GrUserManager size={26} />,
//     path: "/managebussines",
//     permission: "addBranches",
//   },

//   {
//     id: 7,
//     label: "Add Staff",
//     icon: <FaUserPlus size={26} />,
//     path: "/addstaff",
//     permission: "addStaff",
//   },

//   {
//     id: 8,
//     label: "Add Expenses",
//     icon: <FaReceipt size={26} />,
//     path: "/expenses",
//     permission: "expenses",
//   },

//   {
//     id: 9,
//     label: "Get Premium",
//     icon: <MdOutlineWorkspacePremium size={26} />,
//     path: "/premium",
//     permission: "premium",
//   },

//   {
//     id: 10,
//     label: "Generate Barcode",
//     icon: <FaBarcode size={26} />,
//     path: "/generatebarcode",
//     permission: "barcode",
//   },

//   {
//     id: 11,
//     label: "Loyalty Points",
//     icon: <FaCoins size={26} />,
//     path: "/loyalitypoints",
//     permission: "loyaltyPoints",
//   },

  

//   {
//     id: 13,
//     label: "Reports",
//     icon: <TbReportSearch size={26} />,
//     path: "/reports",
//     permission: "reports",
//   },

//   {
//     id: 14,
//     label: "Setting",
//     icon: <IoSettingsSharp size={26} />,
//     path: "/setting",
//     permission: "settings",
//   },
//   {
//   id: 16,
//   label: "Notification",
//   icon: <IoMdNotifications size={26} />,
//   path: "/notificaton",
// },
// {
//   id: 17,
//   label: "Bank Account",
//   icon: <IoCardOutline size={26} />,
//   path: "/bankaccount",
// },
// {
//   id: 18,
//   label: " Add Purchase",
//   icon: <FaShoppingCart size={24} />,
//   path: "/purchase",
// },
// {
//   id: 19,
//   label: " Cash In Hand",
//   icon: <FaMoneyBillWave size={24} />,
//   path: "/cashinhand",
// },

// ];

  

// const getAllowedMenuItems = () => {
//   const normalizedRole = String(role || "")
//     .toLowerCase()
//     .trim();


//   if (normalizedRole !== "staff") {
//     return menuItems;
//   }

//   const staffActions = getStaffActions();

//   console.log("========== SIDEBAR ==========");
//   console.log("ROLE:", normalizedRole);
//   console.log("STAFF ACTIONS:", staffActions);

//   return menuItems.filter((item) => {

    
//     if (item.permission === null) {
//       return true;
//     }

//     const permission = String(item.permission)
//       .toLowerCase()
//       .trim();

//     return staffActions.includes(permission);
//   });
// };

// const allowedMenuItems = getAllowedMenuItems();



//   const itemStyle = (index) => ({
//     padding: "14px 16px",
//     marginBottom: "10px",
//     borderRadius: "12px",
//     cursor: "pointer",
//     transition: "all .3s ease",

//     background:
//       hovered === index
//         ? "linear-gradient(135deg,#5B7FFF,#4F46E5)"
//         : "transparent",

//     boxShadow:
//       hovered === index
//         ? "0 10px 20px rgba(79,70,229,.25)"
//         : "none",
//   });




//   useEffect(() => {
//     if (open && isMobile) {
//       document.body.classList.add("sidebar-open");
//     } else {
//       document.body.classList.remove("sidebar-open");
//     }

//     return () => {
//       document.body.classList.remove("sidebar-open");
//     };
//   }, [open, isMobile]);


//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth <= 768) {
//         setIsMobile(true);
//         setOpen(true);
//       } else {
//         setIsMobile(false);
//         setOpen(true);
//       }
//     };

//     handleResize();

//     window.addEventListener("resize", handleResize);

//     document.body.style.overflowX = "hidden";

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);


//   useEffect(() => {
//     if (open && isMobile) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "auto";
//     }

//     return () => {
//       document.body.style.overflow = "auto";
//     };
//   }, [open, isMobile]);

// const handleLogout = () => {

//   localStorage.removeItem("user_data");
//   localStorage.removeItem("client_id");
//   localStorage.removeItem("role");


//   setIsLogin(false);


//   setShowSidebar(false);
//   setShowLogoutModal(false);

//   navigate("/login", { replace: true });


//   setTimeout(() => {
//     showSuccess("Logout Successful");
//   }, 100);
// };


//   return (
//     <>
//       {/* Mobile overlay */}
//       {isMobile && open && (
//         <div
//           onClick={() => {
//             setOpen(false);
//             setShowSidebar(false);
//           }}
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100vh",
//             background: "rgba(0,0,0,0.4)",
//             zIndex: 998,
//           }}
//         />
//       )}


//       {/* SIDEBAR */}
//       <div
//         className="custom-sidebar"
//         style={{
//           ...styles.sidebar,

//           width: "230px",

//           transform:
//             isMobile && !open
//               ? "translateX(-100%)"
//               : "translateX(0)",

//           transition: "all 0.3s ease",
//         }}
//       >

//         <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             minHeight: "100%",
//           }}
//         >

//           {/* TOP SECTION */}
//           <div>

//             {/* LOGO */}
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "12px",
//                 marginBottom: "35px",
//                 paddingBottom: "20px",
//               }}
//             >

//               <img
//                 src={logo}
//                 alt="logo"
//                 style={{
//                   width: "55px",
//                   height: "55px",
//                   objectFit: "contain",
//                   borderRadius: "10px",
//                 }}
//               />

//               <h2
//                 style={{
//                   margin: 0,
//                   color: "#111827",
//                   fontWeight: "700",
//                   fontSize: "26px",
//                 }}
//               >
//                 Dectwin
//               </h2>

//               <IoMdClose 
//                 size={55}
//                 onClick={() => {
//                   setOpen(false);
//                   setShowSidebar(false);
//                 }}
//                 style={{
//                   cursor: "pointer",
//                   marginLeft: "auto",
//                   color: "#6b7280",
//                 }}
//               />

//             </div>


//             {/* MENU TITLE */}
//             <div
//               style={{
//                 color: "#94a3b8",
//                 fontSize: "12px",
//                 fontWeight: "700",
//                 marginBottom: "15px",
//                 letterSpacing: "1px",
//               }}
//             >
//               MAIN MENU
//             </div>


//             {/* MENU */}
//             <ul
//               style={{
//                 listStyle: "none",
//                 padding: 0,
//                 margin: 0,
//               }}
//             >

//               {/* {allowedMenuItems.map((item) => (

//                 <li
//                   key={item.id}

//                   onMouseEnter={() => setHovered(item.id)}
//                   onMouseLeave={() => setHovered(null)}

//                   onClick={() => {
//                     setShowSidebar(false);
//                     setOpen(false);
//                   }}

//                   style={{
//                     ...itemStyle(item.id),

//                     color:
//                       hovered === item.id
//                         ? "#fff"
//                         : "#111827",
//                   }}
//                 >

//                   <Link
//                     to={item.path}
//                     style={styles.link}

//                     onClick={() => {
//                       if (isMobile) {
//                         setShowSidebar(false);
//                         setOpen(false);
//                       }
//                     }}
//                   >

//                     {item.icon}

//                     <span>
//                       {item.label}
//                     </span>

//                   </Link>

//                 </li>

//               ))} */}
// {allowedMenuItems.map((item) => (
//   <li
//     key={item.id}
//     onMouseEnter={() => setHovered(item.id)}
//     onMouseLeave={() => setHovered(null)}
//     style={{
//       ...itemStyle(item.id),
//       color: hovered === item.id ? "#fff" : "#111827",
//     }}
//   >
//     <Link
//       to={item.path}
//       style={styles.link}
//       onClick={() => {
//         // Mobile par sidebar close karo
//         if (isMobile) {
//           setOpen(false);
//           setShowSidebar(false);
//         }
//       }}
//     >
//       {item.icon}

//       <span>{item.label}</span>
//     </Link>
//   </li>
// ))}
//             </ul>

//           </div>


        
//           <div
//             style={{
//               marginTop: "auto",
//               paddingBottom: "10px",
//             }}
//           >

//             <button
//               onClick={() => {
//                 setShowLogoutModal(true);
//               }}
//               style={styles.logout}
//             >

//               {/* <FaSignOutAlt size={20} />

//               Logout */}
//               <FaSignOutAlt size={20} />

// {String(role || "").toLowerCase() === "staff"
//   ? "Staff Logout"
//   : "Logout"}

//             </button>

//           </div>

//         </div>

//       </div>


     

//       {showLogoutModal && (

//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100vh",

//             background: "rgba(0,0,0,0.5)",

//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",

//             zIndex: 9999,
//           }}
//         >

//           <div
//             style={{
//               width: "350px",
//               background: "#fff",
//               borderRadius: "15px",
//               padding: "25px",
//               textAlign: "center",
//               boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
//             }}
//           >

//             <FaSignOutAlt
//               size={35}
//               color="#ef4444"
//               style={{
//                 marginBottom: "10px",
//               }}
//             />
// {/* 
//             <h3>
//               Logout
//             </h3> */}
//             <h3>
//   {String(role || "").toLowerCase() === "staff"
//     ? "Staff Logout"
//     : "Logout"}
// </h3>

//             <p
//               style={{
//                 color: "#555",
//               }}
//             >
//               Are you sure you want to logout?
//             </p>


//             <div
//               style={{
//                 display: "flex",
//                 gap: "10px",
//                 marginTop: "20px",
//               }}
//             >

//               {/* CANCEL */}
//               <button
//                 onClick={() => {
//                   setShowLogoutModal(false);
//                 }}
//                 style={{
//                   flex: 1,
//                   padding: "10px",
//                   border: "1px solid #ddd",
//                   borderRadius: "8px",
//                   cursor: "pointer",
//                   background: "#fff",
//                 }}
//               >
//                 Cancel
//               </button>


//               {/* LOGOUT */}
//               {/* <button
//                 onClick={handleLogout}
//                 style={{
//                   flex: 1,
//                   padding: "10px",
//                   background: "#ef4444",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: "8px",
//                   cursor: "pointer",
//                 }}
//               >
//                 Logout
//               </button> */}

//               <button
//   onClick={handleLogout}
//   style={{
//     flex: 1,
//     padding: "10px",
//     background: "#ef4444",
//     color: "#fff",
//     border: "none",
//     borderRadius: "8px",
//     cursor: "pointer",
//   }}
// >
//   {String(role || "").toLowerCase() === "staff"
//     ? "Staff Logout"
//     : "Logout"}
// </button>

//             </div>

//           </div>

//         </div>

//       )}

//     </>
//   );
// }




// const styles = {
//   sidebar: {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     width: "230px",
//     height: "100vh",
//     overflowY: "scroll",
//     overflowX: "hidden",
//     background: "#fff",
//     padding: "15px",
//     zIndex: 1000,
//     boxShadow: "0 0 20px rgba(0,0,0,0.08)",
//     borderRight: "1px solid #e5e7eb",
//     boxSizing: "border-box",
//   },

//   link: {
//     color: "inherit",
//     textDecoration: "none",

//     display: "flex",
//     alignItems: "center",

//     gap: "14px",

//     fontSize: "15px",
//     fontWeight: "600",

//     width: "100%",
//   },


//   logout: {
//     background: "#fee2e2",
//     border: "none",

//     color: "#dc2626",

//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",

//     gap: "10px",

//     width: "100%",

//     cursor: "pointer",

//     fontSize: "15px",
//     fontWeight: "600",

//     padding: "14px",

//     borderRadius: "12px",

//     marginTop: "20px",
//   },
// };


// export default Sidebar;
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { FaHome } from "react-icons/fa";
import { FaChartPie } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { FaBoxes } from "react-icons/fa";
import { FaUniversity } from "react-icons/fa";
import { FaBuilding } from "react-icons/fa";
import { FaWallet } from "react-icons/fa";
import { FaUserCog } from "react-icons/fa";
import { FaMoneyBillWave } from "react-icons/fa";
import { FaShoppingCart } from "react-icons/fa";
import { FaChartBar } from "react-icons/fa";
import { FaCog } from "react-icons/fa";
import { FaCrown } from "react-icons/fa";
import { FaBarcode } from "react-icons/fa";
import { FaCoins } from "react-icons/fa";
import { FaBell } from "react-icons/fa";

import { FaQuestionCircle } from "react-icons/fa";
import { FaSignOutAlt } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import logo from "./../assets/dectwin-billing-logo.jpeg";

import {
  showSuccess,
} from "../General/Toast";

function Sidebar({
  setShowSidebar,
  setIsLogin,
  role,
  clientData,
}) {
  const navigate = useNavigate();

  const [hovered, setHovered] = useState(null);
  const [open, setOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [showLogoutModal, setShowLogoutModal] =
    useState(false);

  /* =====================================================
     STAFF PERMISSIONS
  ===================================================== */

  const getStaffActions = () => {
    try {
      const storedUser =
        localStorage.getItem("user_data");

      if (!storedUser) {
        return [];
      }

      const userData = JSON.parse(storedUser);

      let actions = userData?.actions;

      if (!actions) {
        return [];
      }

      while (typeof actions === "string") {
        actions = JSON.parse(actions);
      }

      if (!Array.isArray(actions)) {
        return [];
      }

      return actions
        .map((action) =>
          String(action)
            .toLowerCase()
            .trim()
        )
        .filter(Boolean);
    } catch (error) {
      console.error(
        "Staff permission error:",
        error
      );

      return [];
    }
  };

  /* =====================================================
     MENU ITEMS
  ===================================================== */

const menuItems = [
  {
    id: 1,
    label: "Home",
    icon: <FaHome />,
    path: "/home",
    permission: null,
  },

  {
    id: 2,
    label: "Overview",
    icon: <FaChartPie />,
    path: "/overview",
    permission: null,
  },

  {
    id: 3,
    label: "Parties",
    icon: <FaUsers />,
    path: "/party",
    permission: "addParty",
  },

  {
    id: 4,
    label: "Inventory",
    icon: <FaBoxes />,
    path: "/items",
    permission: "inventory",
  },

  {
    id: 5,
    label: "Bank Account",
    icon: <FaUniversity />,
    path: "/bankaccount",

  },

  {
    id: 6,
    label: "Manage Business",
    icon: <FaBuilding />,
    path: "/managebussines",
    permission: "addBranches",
  },

  {
    id: 7,
    label: "Cash in Hand",
    icon: <FaWallet />,
    path: "/cashinhand",
   
  },

  {
    id: 8,
    label: "Staff Management",
    icon: <FaUserCog />,
    path: "/addstaff",
    permission: "addStaff",
  },

  {
    id: 9,
    label: "Expenses",
    icon: <FaMoneyBillWave />,
    path: "/expenses",
    permission: "expenses",
  },

  {
    id: 10,
    label: "Purchase",
    icon: <FaShoppingCart />,
    path: "/purchase",
    permission: "purchase",
  },

  {
    id: 11,
    label: "Reports",
    icon: <FaChartBar />,
    path: "/reports",
    permission: "reports",
  },

  {
    id: 12,
    label: "Settings",
    icon: <FaCog />,
    path: "/setting",
    permission: "settings",
  },

  {
    id: 13,
    label: "Get Premium",
    icon: <FaCrown />,
    path: "/premium",
    permission: "premium",
  },

  {
    id: 14,
    label: "Generate Barcode",
    icon: <FaBarcode />,
    path: "/generatebarcode",
    permission: "barcode",
  },

  {
    id: 15,
    label: "Loyalty Points",
    icon: <FaCoins />,
    path: "/loyalitypoints",
    permission: "loyaltyPoints",
  },

  {
    id: 16,
    label: "Notification",
    icon: <FaBell />,
    path: "/notificaton",
   
  },

  {
    id: 17,
    label: "Settings",
    icon: <FaCog />,
    path: "/setting",
    permission: "setting",
  },
];

  /* =====================================================
     ALLOWED MENU
  ===================================================== */

  const getAllowedMenuItems = () => {
    const normalizedRole = String(role || "")
      .toLowerCase()
      .trim();

    if (normalizedRole !== "staff") {
      return menuItems;
    }

    const staffActions = getStaffActions();

    return menuItems.filter((item) => {
      if (item.permission === null) {
        return true;
      }

      const permission = String(
        item.permission
      )
        .toLowerCase()
        .trim();

      return staffActions.includes(permission);
    });
  };

  const allowedMenuItems =
    getAllowedMenuItems();

  /* =====================================================
     ACTIVE ROUTE
  ===================================================== */

  const isActive = (path) => {
    const currentPath =
      window.location.pathname;

    if (path === "/home") {
      return (
        currentPath === "/" ||
        currentPath === "/home"
      );
    }

    return currentPath === path;
  };

  /* =====================================================
     RESPONSIVE
  ===================================================== */

  useEffect(() => {
    const handleResize = () => {
      const mobile =
        window.innerWidth <= 768;

      setIsMobile(mobile);

      if (!mobile) {
        setOpen(true);
      }
    };

    handleResize();

    window.addEventListener(
      "resize",
      handleResize
    );

    document.body.style.overflowX =
      "hidden";

    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );

      document.body.style.overflowX =
        "";
    };
  }, []);

  /* =====================================================
     MOBILE BODY LOCK
  ===================================================== */

  useEffect(() => {
    if (open && isMobile) {
      document.body.classList.add(
        "sidebar-open"
      );
    } else {
      document.body.classList.remove(
        "sidebar-open"
      );
    }

    return () => {
      document.body.classList.remove(
        "sidebar-open"
      );
    };
  }, [open, isMobile]);

  /* =====================================================
     CLOSE SIDEBAR
  ===================================================== */

  const closeSidebar = () => {
    setOpen(false);

    if (setShowSidebar) {
      setShowSidebar(false);
    }
  };

  /* =====================================================
     MENU NAVIGATION
  ===================================================== */

  const handleMenuClick = (path) => {
    if (isMobile) {
      closeSidebar();
    }

    navigate(path);
  };


  const handleLogout = () => {
    localStorage.removeItem("user_data");
    localStorage.removeItem("client_id");
    localStorage.removeItem("role");

    setIsLogin(false);

    setShowSidebar(false);
    setShowLogoutModal(false);

    navigate("/login", {
      replace: true,
    });

    setTimeout(() => {
      showSuccess(
        "Logout Successful"
      );
    }, 100);
  };

  return (
    <>
      {/* =================================================
          MOBILE OVERLAY
      ================================================= */}

      {isMobile && open && (
        <div
          className="sidebar-mobile-overlay"
          onClick={closeSidebar}
        />
      )}

      {/* =================================================
          SIDEBAR
      ================================================= */}

      <aside
        className={`app-sidebar ${
          open
            ? "sidebar-open"
            : "sidebar-closed"
        }`}
      >
        <div className="sidebar-inner">

          {/* =================================================
              BRAND
          ================================================= */}

          <div className="sidebar-brand">

            <div className="sidebar-logo-wrap">
              <img
                src={logo}
                alt="Dectwin Billing"
                className="sidebar-logo"
              />
            </div>

            <div className="sidebar-brand-text">
              <div className="sidebar-brand-name">
                Dectwin
              </div>

              <div className="sidebar-brand-subtitle">
                BILLING SOFTWARE
              </div>
            </div>
{/* 
            {isMobile && (
              <button
                type="button"
                className="sidebar-close-btn"
                onClick={closeSidebar}
                aria-label="Close sidebar"
              >
                <IoMdClose />
              </button>
            )} */}
            <button
  type="button"
  className="sidebar-close-btn"
  onClick={closeSidebar}
  aria-label="Close sidebar"
>
  <IoMdClose />
</button>
          </div>

          {/* =================================================
              MENU
          ================================================= */}

          <div className="sidebar-menu">

            <div className="sidebar-section-title">
              MENU
            </div>

            <ul className="sidebar-list">
              {allowedMenuItems.map(
                (item) => {
                  const active =
                    isActive(
                      item.path
                    );

                  return (
                    <li
                      key={item.id}
                      className={`sidebar-list-item ${
                        active
                          ? "sidebar-active"
                          : ""
                      }`}
                      onMouseEnter={() =>
                        setHovered(
                          item.id
                        )
                      }
                      onMouseLeave={() =>
                        setHovered(
                          null
                        )
                      }
                    >
                      <Link
                        to={item.path}
                        className={`sidebar-menu-link ${
                          active
                            ? "active"
                            : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();

                          handleMenuClick(
                            item.path
                          );
                        }}
                      >
                        <span className="sidebar-menu-icon">
                          {item.icon}
                        </span>

                        <span className="sidebar-menu-label">
                          {item.label}
                        </span>
                      </Link>
                    </li>
                  );
                }
              )}
            </ul>
          </div>

          {/* =================================================
              BOTTOM
          ================================================= */}

          <div className="sidebar-bottom">

            {/* PREMIUM */}

            {/* <button
              type="button"
              className="sidebar-premium-card"
              onClick={() =>
                handleMenuClick(
                  "/premium"
                )
              }
            >
              <div className="premium-icon">
                <FaCrown />
              </div>

              <div className="premium-content">
                <div className="premium-title">
                  Upgrade to Pro
                </div>

                <div className="premium-text">
                  Get advanced features for
                  your growing business
                </div>
              </div>

              <span className="premium-arrow">
                ›
              </span>
            </button> */}

            {/* HELP */}
{/* 
            <button
              type="button"
              className="sidebar-help-btn"
              onClick={() => {
                console.log(
                  "Help & Support clicked"
                );
              }}
            >
              <FaQuestionCircle />

              <span>
                Help & Support
              </span>
            </button> */}

            {/* LOGOUT */}

            <button
              type="button"
              className="sidebar-logout-btn"
              onClick={() =>
                setShowLogoutModal(
                  true
                )
              }
            >
              <FaSignOutAlt />

              <span>
                {String(role || "")
                  .toLowerCase() ===
                "staff"
                  ? "Staff Logout"
                  : "Logout"}
              </span>
            </button>
          </div>
        </div>
      </aside>

      {/* =====================================================
          LOGOUT MODAL
      ===================================================== */}

      {showLogoutModal && (
        <div className="sidebar-modal-overlay">

          <div className="sidebar-logout-modal">

            <div className="logout-icon">
              <FaSignOutAlt />
            </div>

            <h3>
              {String(role || "")
                .toLowerCase() ===
              "staff"
                ? "Staff Logout"
                : "Logout"}
            </h3>

            <p>
              Are you sure you want
              to logout?
            </p>

            <div className="logout-actions">

              <button
                type="button"
                className="logout-cancel"
                onClick={() =>
                  setShowLogoutModal(
                    false
                  )
                }
              >
                Cancel
              </button>

              <button
                type="button"
                className="logout-confirm"
                onClick={handleLogout}
              >
                {String(role || "")
                  .toLowerCase() ===
                "staff"
                  ? "Staff Logout"
                  : "Logout"}
              </button>

            </div>
          </div>
        </div>
      )}

      {/* =====================================================
          SIDEBAR CSS
      ===================================================== */}

      <style>{`

        * {
          box-sizing: border-box;
        }

        /* ================================================
           DESKTOP
        ================================================= */

//         .app-sidebar {
//           position: fixed;

//           top: 0;
//           left: 0;

//           width: 170px;
//           height: 100vh;

//           background:
//             linear-gradient(
//               180deg,
//               #06295f 0%,
//               #06265a 50%,
//               #041e49 100%
//             );

//           color: #ffffff;

//           z-index: 10000;

//           overflow: hidden;

//           box-shadow:
//             4px 0 18px
//             rgba(0, 0, 0, 0.12);

//           transform: translateX(0);

//           transition:
//             transform 0.28s
//             ease-in-out;
//         }

//         .sidebar-inner {
//           width: 100%;
//           height: 100%;

//           display: flex;
//           flex-direction: column;

//           padding:
//             14px 9px 10px;
//         }

//         /* ================================================
//            BRAND
//         ================================================= */

//         .sidebar-brand {
//           display: flex;
//           align-items: center;

//           gap: 9px;

//           padding:
//             2px 5px 14px;

//           border-bottom:
//             1px solid
//             rgba(255,255,255,0.10);

//           flex-shrink: 0;
//         }

//         .sidebar-logo-wrap {
//           width: 42px;
//           height: 42px;

//           min-width: 42px;

//           border-radius: 9px;

//           overflow: hidden;

//           background: #ffffff;

//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         .sidebar-logo {
//           width: 100%;
//           height: 100%;

//           object-fit: cover;
//         }

//         .sidebar-brand-text {
//           min-width: 0;
//           flex: 1;
//         }

//         .sidebar-brand-name {
//           color: #ffffff;

//           font-size: 17px;
//           font-weight: 800;

//           line-height: 18px;
//         }

//         .sidebar-brand-subtitle {
//           color: #8ea9d1;

//           font-size: 6px;
//           font-weight: 700;

//           letter-spacing: 0.7px;

//           margin-top: 2px;
//         }
// .sidebar-close-btn {
//   position: absolute !important;

//   top: 8px;
//   right: 4px !important;

//   width: 20px !important;
//   height: 20px !important;
//   min-width: 20px !important;

//   border: 0 !important;
//   border-radius: 50% !important;

//   background: rgba(255, 255, 255, 0.12) !important;
//   color: #fff !important;

//   display: flex !important;
//   align-items: center;
//   justify-content: center;

//   padding: 0 !important;
//   margin: 0 !important;

//   font-size: 20px !important;
//   line-height: 1;

//   cursor: pointer;
//   z-index: 20;
// }
/* ================================================
   DESKTOP SIDEBAR
================================================ */

.app-sidebar {
  position: fixed;

  top: 0;
  left: 0;

  /* Increased width */
  width: 200px;
  height: 100vh;

  background:
    linear-gradient(
      180deg,
      #06295f 0%,
      #06265a 50%,
      #041e49 100%
    );

  color: #ffffff;

  z-index: 10000;

  overflow: hidden;

  box-shadow:
    4px 0 18px
    rgba(0, 0, 0, 0.12);

  transform: translateX(0);

  transition:
    transform 0.28s
    ease-in-out;
}


/* ================================================
   SIDEBAR INNER
================================================ */

.sidebar-inner {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;

  padding: 16px 12px 12px;
}


/* ================================================
   BRAND
================================================ */

.sidebar-brand {
  display: flex;
  align-items: center;

  /* Increased gap */
  gap: 12px;

  padding:
    3px 7px 16px;

  border-bottom:
    1px solid
    rgba(255,255,255,0.10);

  flex-shrink: 0;
}


/* ================================================
   LOGO
================================================ */

.sidebar-logo-wrap {
  width: 46px;
  height: 46px;

  min-width: 46px;

  border-radius: 10px;

  overflow: hidden;

  background: #ffffff;

  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar-logo {
  width: 100%;
  height: 100%;

  object-fit: cover;
}


/* ================================================
   BRAND TEXT
================================================ */

.sidebar-brand-text {
  min-width: 0;
  flex: 1;
}

.sidebar-brand-name {
  color: #ffffff;

  font-size: 19px;
  font-weight: 800;

  line-height: 21px;

  white-space: nowrap;
}

.sidebar-brand-subtitle {
  color: #8ea9d1;

  font-size: 7px;
  font-weight: 700;

  letter-spacing: 0.9px;

  margin-top: 3px;

  white-space: nowrap;
}


/* ================================================
   CLOSE BUTTON
================================================ */

.sidebar-close-btn {
  position: absolute !important;

  top: 10px;
  right: 7px !important;

  width: 24px !important;
  height: 24px !important;
  min-width: 24px !important;

  border: 0 !important;
  border-radius: 50% !important;

  background:
    rgba(255, 255, 255, 0.14) !important;

  color: #fff !important;

  display: flex !important;
  align-items: center;
  justify-content: center;

  padding: 0 !important;
  margin: 0 !important;

  font-size: 21px !important;
  line-height: 1;

  cursor: pointer;

  z-index: 20;
}


/* ================================================
   MENU
================================================ */

.sidebar-menu {
  flex: 1;

  min-height: 0;

  overflow-y: auto;
  overflow-x: hidden;

  padding-top: 18px;

  scrollbar-width: none;
}

.sidebar-menu::-webkit-scrollbar {
  display: none;
}


/* ================================================
   MENU TITLE
================================================ */

.sidebar-section-title {
  color: #6f91bd;

  font-size: 10px;
  font-weight: 800;

  letter-spacing: 1.2px;

  padding:
    0 11px 9px;
}


/* ================================================
   MENU ITEM
================================================ */

.sidebar-list-item {
  width: 100%;

  margin-bottom: 3px;
}


/* ================================================
   MENU LINK
================================================ */

.sidebar-menu-link {
  width: 100%;

  min-height: 40px;

  display: flex;
  align-items: center;

  /* Increased gap */
  gap: 12px;

  padding:
    8px 11px;

  border-radius: 8px;

  color: #d9e5f5;

  text-decoration: none;

  /* Increased font */
  font-size: 13px;
  line-height: 17px;
  font-weight: 600;

  transition:
    background 0.18s ease,
    color 0.18s ease;
}

.sidebar-menu-link:hover {
  color: #ffffff;

  background:
    rgba(255,255,255,0.08);

  text-decoration: none;
}

.sidebar-menu-link.active {
  color: #ffffff;

  background:
    linear-gradient(
      90deg,
      #0878ff,
      #086bf0
    );

  box-shadow:
    0 5px 12px
    rgba(0, 113, 255, 0.25);
}


/* ================================================
   MENU ICON
================================================ */

.sidebar-menu-icon {
  width: 19px;
  min-width: 19px;

  height: 19px;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 14px;
}

.sidebar-menu-icon svg {
  width: 14px;
  height: 14px;
}


/* ================================================
   MENU LABEL
================================================ */

.sidebar-menu-label {
  white-space: nowrap;

  overflow: hidden;

  text-overflow: ellipsis;
}


/* ================================================
   BOTTOM
================================================ */

.sidebar-bottom {
  flex-shrink: 0;

  padding-top: 11px;
}


/* ================================================
   LOGOUT
================================================ */

.sidebar-help-btn,
.sidebar-logout-btn {
  width: 100%;

  min-height: 44px;

  border: 0;
  background: transparent;

  color: #a9bfdb;

  display: flex;
  align-items: center;

  gap: 13px;

  padding: 10px 12px;

  border-radius: 8px;

  font-size: 16px;
  line-height: 20px;
  font-weight: 700;

  cursor: pointer;
  text-align: left;
}

.sidebar-help-btn svg,
.sidebar-logout-btn svg {
  width: 18px;
  height: 18px;
}

.sidebar-help-btn:hover,
.sidebar-logout-btn:hover {
  background:
    rgba(255,255,255,0.07);

  color: #ffffff;
}

.sidebar-help-btn svg,
.sidebar-logout-btn svg {
  width: 15px;
  height: 15px;
}

.sidebar-logout-btn {
  color: #ff9e9e;
}
        // .sidebar-close-btn {
        //   border: 0;

        //   background: transparent;

        //   color: #ffffff;

        //   width: 30px;
        //   height: 30px;

        //   display: flex;
        //   align-items: center;
        //   justify-content: center;

        //   font-size: 21px;

        //   cursor: pointer;

        //   flex-shrink: 0;
        // }

        /* ================================================
           MENU
        ================================================= */

        .sidebar-menu {
          flex: 1;

          min-height: 0;

          overflow-y: auto;
          overflow-x: hidden;

          padding-top: 14px;

          scrollbar-width: none;
        }

        .sidebar-menu::-webkit-scrollbar {
          display: none;
        }

        .sidebar-section-title {
          color: #6f91bd;

          font-size: 8px;
          font-weight: 700;

          letter-spacing: 1px;

          padding:
            0 10px 8px;
        }

        .sidebar-list {
          list-style: none;

          padding: 0;
          margin: 0;
        }

        .sidebar-list-item {
          width: 100%;

          margin-bottom: 2px;
        }

        .sidebar-menu-link {
          width: 100%;

          min-height: 34px;

          display: flex;
          align-items: center;

          gap: 10px;

          padding:
            7px 10px;

          border-radius: 7px;

          color: #d9e5f5;

          text-decoration: none;

          font-size: 10px;
          font-weight: 500;

          transition:
            background 0.18s ease,
            color 0.18s ease;
        }

        .sidebar-menu-link:hover {
          color: #ffffff;

          background:
            rgba(255,255,255,0.08);

          text-decoration: none;
        }

        .sidebar-menu-link.active {
          color: #ffffff;

          background:
            linear-gradient(
              90deg,
              #0878ff,
              #086bf0
            );

          box-shadow:
            0 5px 12px
            rgba(0, 113, 255, 0.25);
        }
.sidebar-menu-icon {
  width: 17px !important;
  min-width: 17px !important;
  height: 17px !important;
}

          display: flex;
          align-items: center;
          justify-content: center;

          font-size: 12px;
        }

        .sidebar-menu-icon svg {
          width: 13px;
          height: 13px;
        }

        .sidebar-menu-label {
          white-space: nowrap;

          overflow: hidden;

          text-overflow: ellipsis;
        }

        /* ================================================
           BOTTOM
        ================================================= */

        .sidebar-bottom {
          flex-shrink: 0;

          padding-top: 9px;
        }

        .sidebar-premium-card {
          width: 100%;

          border:
            1px solid
            rgba(255,255,255,0.08);

          border-radius: 9px;

          background:
            linear-gradient(
              135deg,
              rgba(16,74,145,0.95),
              rgba(6,43,94,0.95)
            );

          padding: 9px 8px;

          display: flex;
          align-items: center;

          gap: 7px;

          color: #ffffff;

          text-align: left;

          cursor: pointer;

          margin-bottom: 7px;
        }

        .premium-icon {
          width: 25px;
          height: 25px;

          min-width: 25px;

          border-radius: 7px;

          background: #ffca28;

          color: #714e00;

          display: flex;
          align-items: center;
          justify-content: center;

          font-size: 12px;
        }

        .premium-content {
          flex: 1;

          min-width: 0;
        }

        .premium-title {
          color: #ffffff;

          font-size: 8px;
          font-weight: 700;

          line-height: 11px;
        }

        .premium-text {
          color: #9db6d7;

          font-size: 6.5px;

          line-height: 9px;

          margin-top: 2px;
        }

        .premium-arrow {
          color: #8eabd0;

          font-size: 17px;
        }

        .sidebar-help-btn,
        .sidebar-logout-btn {
          width: 100%;

          border: 0;

          background: transparent;

          color: #a9bfdb;

          display: flex;
          align-items: center;

          gap: 9px;

          padding:
            8px 10px;

          border-radius: 7px;

          font-size: 9px;
          font-weight: 500;

          cursor: pointer;

          text-align: left;
        }

        .sidebar-help-btn:hover,
        .sidebar-logout-btn:hover {
          background:
            rgba(255,255,255,0.07);

          color: #ffffff;
        }

        .sidebar-help-btn svg,
        .sidebar-logout-btn svg {
          width: 12px;
          height: 12px;
        }

        .sidebar-logout-btn {
          color: #ff9e9e;
        }

        /* ================================================
           LOGOUT MODAL
        ================================================= */

        .sidebar-modal-overlay {
          position: fixed;

          inset: 0;

          background:
            rgba(0,0,0,0.55);

          z-index: 99999;

          display: flex;

          align-items: center;
          justify-content: center;

          padding: 20px;
        }

        .sidebar-logout-modal {
          width: 100%;

          max-width: 350px;

          background: #ffffff;

          border-radius: 16px;

          padding: 25px;

          text-align: center;

          box-shadow:
            0 20px 50px
            rgba(0,0,0,0.25);
        }

        .logout-icon {
          width: 55px;
          height: 55px;

          margin: 0 auto 12px;

          border-radius: 50%;

          background: #fee2e2;

          color: #ef4444;

          display: flex;
          align-items: center;
          justify-content: center;

          font-size: 23px;
        }

        .sidebar-logout-modal h3 {
          margin: 0;

          color: #172033;

          font-size: 20px;
          font-weight: 700;
        }

        .sidebar-logout-modal p {
          color: #6b7280;

          font-size: 13px;

          margin:
            8px 0 20px;
        }

        .logout-actions {
          display: flex;

          gap: 10px;
        }

        .logout-cancel,
        .logout-confirm {
          flex: 1;

          border-radius: 8px;

          padding: 10px;

          cursor: pointer;

          font-weight: 600;
        }

        .logout-cancel {
          background: #ffffff;

          color: #374151;

          border:
            1px solid #e5e7eb;
        }

        .logout-confirm {
          background: #ef4444;

          color: #ffffff;

          border: 0;
        }

        /* ================================================
           MOBILE
        ================================================= */
@media (max-width: 768px) {

  .app-sidebar {
    width: 170px !important;
    max-width: 78vw !important;
    height: 100dvh !important;

    transform: translateX(-105%) !important;

    z-index: 10001 !important;

    border-radius: 0 14px 14px 0 !important;

    transition:
      transform 0.28s ease-in-out !important;
  }

  .app-sidebar.sidebar-open {
    transform: translateX(0) !important;
  }

  .app-sidebar.sidebar-closed {
    transform: translateX(-105%) !important;
  }

  /* ================= SIDEBAR INNER ================= */

  .sidebar-inner {
    padding:
      10px 8px
      calc(70px + env(safe-area-inset-bottom))
      !important;
  }

  /* ================= BRAND ================= */

  .sidebar-brand {
    position: relative !important;

    display: flex !important;
    align-items: center !important;

    gap: 7px !important;

    padding: 3px 34px 11px 3px !important;

    border-bottom:
      1px solid rgba(255,255,255,0.12) !important;

    flex-shrink: 0 !important;
  }

  .sidebar-logo-wrap {
    width: 32px !important;
    height: 32px !important;
    min-width: 32px !important;
  }

  .sidebar-logo-wrap img {
    width: 32px !important;
    height: 32px !important;
  }

  .sidebar-brand-name {
    font-size: 12px !important;
    line-height: 14px !important;
    font-weight: 700 !important;
    white-space: nowrap !important;
  }

  .sidebar-brand-subtitle {
    font-size: 5.5px !important;
    line-height: 7px !important;
    font-weight: 600 !important;
    white-space: nowrap !important;
  }

  /* ================= CLOSE BUTTON ================= */

  .sidebar-close-btn {
    position: absolute !important;

    top: 5px !important;
    right: 3px !important;

    width: 25px !important;
    height: 25px !important;
    min-width: 25px !important;

    padding: 0 !important;
    margin: 0 !important;

    font-size: 16px !important;
    line-height: 1 !important;

    display: flex !important;
    align-items: center !important;
    justify-content: center !important;

    border-radius: 50% !important;
  }

  /* ================= MENU TITLE ================= */

.sidebar-section-title {
  font-size: 10px !important;
  line-height: 13px !important;
  font-weight: 800 !important;
  padding: 10px 8px 6px !important;
  letter-spacing: 1px !important;
}
  /* ================= MENU ITEM ================= */
.sidebar-menu-link {
  min-height: 35px !important;
  padding: 7px 8px !important;
  gap: 8px !important;
  border-radius: 7px !important;

  font-size: 13px !important;
  line-height: 16px !important;
  font-weight: 600 !important;

  white-space: nowrap !important;
}

  /* ================= ICON ================= */

  .sidebar-menu-icon {
    width: 15px !important;
    min-width: 15px !important;

    height: 15px !important;

    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

.sidebar-menu-icon svg {
  width: 13px !important;
  height: 13px !important;
}

  /* ================= BOTTOM ================= */

  .sidebar-bottom {
    padding-top: 7px !important;
    padding-bottom: 4px !important;
  }

  .sidebar-premium-card {
    padding: 6px !important;

    gap: 5px !important;

    border-radius: 8px !important;
  }

  .premium-icon {
    width: 22px !important;
    height: 22px !important;
    min-width: 22px !important;
  }

  .premium-title {
    font-size: 7px !important;
    line-height: 9px !important;
    font-weight: 700 !important;
  }

  .premium-text {
    font-size: 5.5px !important;
    line-height: 7px !important;
  }

.sidebar-help-btn,
.sidebar-logout-btn {
  min-height: 36px !important;
  padding: 8px 9px !important;
  gap: 9px !important;

  font-size: 14px !important;
  line-height: 18px !important;
  font-weight: 700 !important;
}
}
        /* ================================================
           LARGE DESKTOP
        ================================================= */

        @media (min-width: 1200px) {
          .app-sidebar {
            width: 220px;
          }
        }

      `}</style>
    </>
  );
}

export default Sidebar;